import Vue from 'vue'
import App from './App.vue'

import AOS from 'aos'
import 'aos/dist/aos.css'

import VueParallaxJs from 'vue-parallax-js'

// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";

const options = {
  minWidth: 700
}

Vue.use(VueParallaxJs, options)
Vue.config.productionTip = false

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAsk2-nYgVhGLZjosSpwhnAnvnO490PgRQ",
  authDomain: "little-asia-bf77a.firebaseapp.com",
  projectId: "little-asia-bf77a",
  storageBucket: "little-asia-bf77a.appspot.com",
  messagingSenderId: "1059948652361",
  appId: "1:1059948652361:web:dd89d7de03a327718c5c98",
  measurementId: "G-52MNM99KM7"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// eslint-disable-next-line no-unused-vars
const analytics = getAnalytics(app);

new Vue({
  created () {
    AOS.init({
      duration: 1000,
      disable: 'phone'
    })
  },
  render: h => h(App)
}).$mount('#app')
